export default __webpack_public_path__ + "9ee36c8ad1e52292f93dadbdaa0418d4.png";